export const CART_SOURCE_TYPES = {
  EBOOK_SEARCH_RESULT_ITEM: 'ebook-search-result-item',
  PRODUCT_PRICING_MODEL: 'product-pricing-model',
};

export const MOCK_PRICING_TIER_ID = 'mockPricingTier';

export const EBOOK_CART_ICON = '/content/dam/esrisites/en-us/common/icons/meridian-/arcgis-book-48.svg';
export const EBOOK_PAGE_URL = '/en-us/store/ebooks';

export const EPN_REFERENCE_ID = 'epn_id';
export const PROSPECT_ID = 'prosId';
export const SF_REFERENCE_ID = 'sf_id';
